export const EcardTypes = {
    Standard: 0,
    GiftThatMatters: 1,
};
